import React from "react";

import PrimeSubscriptionModalUIProvider from "./PrimeSubscriptionModalProvider";
import PrimeLightboxAccordionProvider from "~/clientState/providers/PrimeLightboxAccordionProvider";

export function PrimeSubscriptionModalUIProviderFunction({ children }) {
  return (
    <PrimeSubscriptionModalUIProvider initialState={false}>
      {children}
    </PrimeSubscriptionModalUIProvider>
  );
}

export function PrimeLightboxAccordionProviderFunction({ children }) {
  return (
    <PrimeLightboxAccordionProvider initialAccordionState={undefined}>
      {children}
    </PrimeLightboxAccordionProvider>
  );
}

export { MembershipPageProvider } from "./pages/MembershipPageProvider";
export { PrimePaymentProvider } from "./pages/PrimePaymentProvider";
export {
  MembershipProductEvaluationOF1Provider,
  MembershipProductEvaluationProvider,
} from "./acquisition/MembershipProductEvaluation";
